import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { Subject, takeUntil } from 'rxjs';
import { CustomerSelectionBaseComponent } from '../customer-selection-base.component';
import { CustomerSelectionOption } from '../../../../../customer/models/customer-selection-option.model';

@Component({
  selector: 'app-customer-selection-payments-touch',
  templateUrl: './customer-selection-payments-touch.component.html',
  styleUrls: ['./customer-selection-payments-touch.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerSelectionPaymentsTouchComponent
  extends CustomerSelectionBaseComponent
  implements OnInit
{
  @Input() isPresentedInFilterModal = true;
  @Input() show = true;
  @Input() selectedCustomers: CustomerSelectionOption[];
  @Output() customersToFilterSelected = new EventEmitter<
    CustomerSelectionOption[]
  >();
  destroyed$ = new Subject<void>();
  protected allSelected = false;
  protected showAllCustomers = false;
  protected initializeSelected = true;
  protected allCustomers: CustomerSelectionOption[] = [];
  protected isMobile = false;

  constructor(
    modalController: ModalController,
    popoverController: PopoverController,
    platformService: PlatformService,
  ) {
    super(modalController, popoverController, platformService);
  }

  ngOnInit(): void {
    this.vm$.pipe(takeUntil(this.destroyed$)).subscribe(res => {
      this.allCustomers = res.customerSelectionOptions;
      this.showAllCustomers = res.showAllCustomersOption;
      this.filterSelectedCustomers();

      if (this.showAllCustomers) {
        this.allSelected =
          this.allCustomers.length > 0 &&
          this.allCustomers.every(c => c.isSelected);
      } else {
        this.allSelected = false;
      }

      this.isMobile =
        res.platformType === this.platformService?.platformEnum?.mobile;
    });
  }

  ionViewWillEnter(): void {
    window.dispatchEvent(new Event('resize'));
  }

  ionViewWillLeave(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  selectCustomer(
    customerSelectionOption: CustomerSelectionOption,
    index: number,
  ) {
    this.allCustomers[index].isSelected = !this.allCustomers[index].isSelected;

    if (this.allCustomers[index].isSelected) {
      this.selectedCustomers.push(customerSelectionOption);
    } else {
      this.selectedCustomers.splice(
        this.selectedCustomers.findIndex(
          c => c.customerNumber === customerSelectionOption.customerNumber,
        ),
        1,
      );
    }

    if (!this.isPresentedInFilterModal) {
      this.customersToFilterSelected.emit(this.selectedCustomers);
    }
    this.allSelected =
      this.selectedCustomers.length === this.allCustomers.length;
  }

  selectAllCustomers() {
    this.allSelected = !this.allSelected;
    this.allCustomers.forEach(customer => {
      customer.isSelected = this.allSelected;
    });

    if (this.allSelected) {
      this.selectedCustomers.splice(0, this.selectedCustomers.length);
      this.selectedCustomers.push(...this.allCustomers);
    } else {
      this.selectedCustomers.splice(0, this.selectedCustomers.length);
    }
    this.initializeSelected = false;

    if (!this.isPresentedInFilterModal) {
      this.customersToFilterSelected.emit(this.selectedCustomers);
    }
  }

  filterSelectedCustomers() {
    if (this.initializeSelected && !!!this.selectedCustomers) {
      this.selectedCustomers = this.allCustomers.filter(
        c => c.isSelected === true,
      );
    } else {
      this.selectedCustomers ??= [];
      this.allCustomers.forEach(customer => {
        customer.isSelected =
          this.selectedCustomers.findIndex(
            c => c.customerNumber === customer.customerNumber,
          ) !== -1;
      });
    }
    this.initializeSelected = false;
  }
}
